import { motion } from "framer-motion";
import { TID } from "@/lib/testIds";

const CHAPTERS = [
  {
    title: "Train.",
    body: "No filler drills. Every session is engineered around the player in front of me — footwork, finishing, decisions. Progress you can measure in weeks, not seasons.",
  },
  {
    title: "Believe.",
    body: "Players don't become confident by accident. They become confident because someone believed in them out loud, then gave them the tools to prove it right.",
  },
  {
    title: "Achieve.",
    body: "The game rewards the ones who trust the work. Court IQ, poise under pressure, and results that show up on the scoreboard — and long after the buzzer.",
  },
];

const chapterVariants = {
  hidden: { opacity: 0, y: 60 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 1,
      ease: [0.22, 1, 0.36, 1],
      delay: i * 0.05,
    },
  }),
};

export const ManifestoSection = () => (
  <section
    id="philosophy"
    data-testid={TID.manifesto}
    className="relative py-32 md:py-48 px-6 md:px-12 bg-[#080f1e]"
  >
    <div className="max-w-[1600px] mx-auto">
      <div className="grid grid-cols-12 gap-6 mb-20 md:mb-32">
        <div className="col-span-12 md:col-span-4">
          <div className="chapter-num mb-6">Manifesto</div>
        </div>
        <div className="col-span-12 md:col-span-8">
          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-15%" }}
            transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
            className="font-display uppercase text-5xl md:text-7xl leading-[0.9] tracking-tight"
          >
            Three words that shape every whistle,
            <span className="text-[#2a5fdb]"> every session.</span>
          </motion.h2>
        </div>
      </div>

      <div className="grid grid-cols-12 gap-x-6 gap-y-16 md:gap-y-20">
        {CHAPTERS.map((c, i) => (
          <motion.article
            key={c.title}
            custom={i}
            variants={chapterVariants}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-10%" }}
            className="col-span-12 md:col-span-4 border-t border-white/10 pt-10"
          >
            <h3 className="font-display uppercase text-4xl md:text-6xl leading-[0.95] tracking-tight text-[#2a5fdb]">
              {c.title}
            </h3>
            <p className="mt-8 text-white/70 text-base leading-relaxed max-w-md">
              {c.body}
            </p>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);
